import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from '../../node_modules/prop-types/index.js';
import { textColorText, textColorTextHover } from '../../theme/text-theme.js';
import { textSettings, fontSettings } from '../../theme/constants/font-constants.js';
import { TEXT_PROPTYPES } from '../../constants/proptypes.js';
import '../../App.css.js';
var _excluded = ["fontFamily", "type", "fontSize", "fontWeight", "color", "colorHover", "hover", "isMobile", "className", "style", "onClick", "onMouseDown", "tag", "tabIndex"];
var TextWrapper = styled.p.withConfig({
  displayName: "textcomponent__TextWrapper",
  componentId: "sc-15gki1c-0"
})(["transition:0.2s;", " ", ";margin-top:0px;margin-bottom:0px;", " &.marginTopLandingStandard{margin-top:34px;}&:hover{", ";}@media screen and (max-width:768px){", " &.marginTopLandingStandard{margin-top:24px;}}"], textSettings, function (props) {
  return TEXT_PROPTYPES.color_text_list.includes(props.color) ? textColorText : props.color == "unset" ? textColorTextUnset : "color: " + props.color;
}, function (props) {
  return props.fontWeight ? fontSettings : "";
}, function (props) {
  return (TEXT_PROPTYPES.color_text_list.includes(props.color) || !props.colorHover) && props.hover ? textColorTextHover : props.hover && props.colorHover ? "color: " + props.colorHover : "";
}, textSettings);
TextWrapper.propTypes = {
  fontFamily: PropTypes.oneOf(TEXT_PROPTYPES.font_family_list),
  type: PropTypes.oneOf(TEXT_PROPTYPES.type_list),
  fontSize: PropTypes.oneOf(TEXT_PROPTYPES.font_size_list),
  isMobile: PropTypes.oneOf(TEXT_PROPTYPES.is_mobile_list)
};
TextWrapper.defaultProps = {
  color: "default",
  fontFamily: "euclid",
  fontSize: "large",
  type: "display",
  isMobile: "false"
};
var getTagFromType = function getTagFromType(type) {
  var tag = "";
  switch (type) {
    case "display":
      tag = "h2";
      break;
    case "heading":
      tag = "h4";
      break;
    case "label":
      tag = "p";
      break;
    case "paragraph":
      tag = "p";
      break;
  }
  return tag;
};
var Text = function Text(_ref) {
  var fontFamily = _ref.fontFamily,
    type = _ref.type,
    fontSize = _ref.fontSize,
    fontWeight = _ref.fontWeight,
    color = _ref.color,
    colorHover = _ref.colorHover,
    hover = _ref.hover,
    isMobile = _ref.isMobile,
    className = _ref.className,
    style = _ref.style,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    tag = _ref.tag,
    tabIndex = _ref.tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(TextWrapper, _extends({
    as: tag ? tag : getTagFromType(type),
    style: style,
    color: color,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
    type: type,
    hover: hover ? true : false,
    colorHover: colorHover,
    isMobile: isMobile ? "true" : "false",
    className: className,
    onClick: onClick,
    onMouseDown: onMouseDown,
    tabIndex: tabIndex
  }, rest), rest.children);
};
export { Text as default };